module.exports = __webpack_public_path__ + "de0113d8d085f19d91b23730e936149e.MP3";